import { ResourcePermissions } from '@/features/users/types/types';

export const hasResourcePermissions = (
  permissions?: string[],
  resourcePermissions?: ResourcePermissions
) =>
  resourcePermissions &&
  permissions &&
  permissions?.some(permission => resourcePermissions.permissions?.includes(permission));
